/*
 * @Description: 用户参与度
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 15:30:15
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p6.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts';

import {getKOL} from '../../../controller';
import {KOL} from '../../../chart';
import { getSessionQuery } from '../../../utils';

class P6 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      infoPlat: {
        max: '',
        ttAuthentication: Number,
        wbAuthentication: Number,
        wxAuthentication: Number,
        zhAuthentication: Number,
      },
      
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      // result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();
    getKOL(query)
      .then(data => {
        this.setState({
          query: query,
          infoPlat: {
            max: data.highlight.max_plat,
            ttAuthentication: data.ttAuthentication,
            wbAuthentication: data.wbAuthentication,
            wxAuthentication: data.wxAuthentication,
            zhAuthentication: data.zhAuthentication,
          },
          chart: KOL(data, query)
        })
      });
  }

  hasData (num) {
    if (num > 0) {
      return `参与讨论的认证账号有${num}人次`
    }

    return '没有参与讨论的认证账号'
  }

  render() {
    const {query, infoPlat} = this.state
    return (
      <div className={s.container}>
        <ExportHeadTitle>用户参与度 – 用户价值分析</ExportHeadTitle>

        <div>
          <ExportDes>
            本周，{query.brandName}在{infoPlat.max}平台上引发KOL关注和参与的人次最多。
            <br/>
            在微信平台上，{this.hasData(infoPlat.wxAuthentication)}；
            在微博平台上，{this.hasData(infoPlat.wbAuthentication)}；
            <br/>
            在今日头条平台上，{this.hasData(infoPlat.ttAuthentication)}；
            在知乎平台上，{this.hasData(infoPlat.zhAuthentication)}。
          </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <ExportEcharts option={this.state.chart}></ExportEcharts>
        </div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P6);



// WEBPACK FOOTER //
// src/routes/exportPDF/p6/p6.js